// 📁 src/redux/slices/TitleBookBubOptionsSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

// ✅ Types
interface TitleBookBubOption {
  label: string;
  value: string;
}

interface FetchTitleBookBubParams {
  page?: number;
  limit?: number;
  searchTerm?: string | null | any;
  ISBN?: any;
  TITLE?: any;
  DEAL_DATE?: any;
}

interface TitleBookBubOptionsState {
  TitleBookBubOption: any;
  loading: boolean;
  error: string | null;
  hasMore: boolean;
  currentPage: number;
  limit: number;
  LoadingofisbnBookBub:boolean
  LoadingofTitleBookBUb:boolean
  LoadingofDealBookBub:boolean
}

// ✅ Initial State
const initialState: TitleBookBubOptionsState = {
  TitleBookBubOption: [],
  loading: false,
  error: null,
  hasMore: true,
  currentPage: 1,
  limit: 10,
  LoadingofTitleBookBUb:false,
    LoadingofDealBookBub:false,
  LoadingofisbnBookBub:false
};

export const FetchTitleBookBub = createAsyncThunk(
  "FetchTitleBookBub",
  async (params: FetchTitleBookBubParams = {}, { rejectWithValue }) => {
    try {
      const queryParams: string[] = [];

      if (params.page !== undefined) queryParams.push(`page=${params.page}`);
      if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
      if (params.searchTerm !== undefined)
        queryParams.push(`searchTerm=${params.searchTerm}`);
      // if (params.DATE?.length) queryParams.push(`DATE=${params.DATE}`);
      if (Array.isArray(params.ISBN)) {
        params.ISBN.forEach((isbn) => {
          queryParams.push(`ISBN=${encodeURIComponent(isbn)}`);
        });
      }
      if (Array.isArray(params.TITLE)) {
        params.TITLE.forEach((title) => {
          queryParams.push(`TITLE=${encodeURIComponent(title)}`);
        });
      }
      if (Array.isArray(params.DEAL_DATE)) {
        params.DEAL_DATE.forEach((file) => {
          queryParams.push(`DEAL_DATE=${encodeURIComponent(file)}`);
        });
      }

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await axios.get(
        `${API.GetBookBubTitleOptions}${queryString}`
      );

      return {
        data: response.data,
        page: params.page ?? 1,
      };
    } catch (err: any) {
      if (err.response?.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

const TitleBookBubOptionsSlice = createSlice({
  name: "TitleBookBubOptions",
  initialState,
  reducers: {
    clearTitleBookBubOptions: (state) => {
      state.TitleBookBubOption = [];
      state.currentPage = 1;
      state.hasMore = true;
      state.loading = false;
      state.error = null;
    },
    setLoadingofTitleBookBub:(state,action)=>{
      state.LoadingofTitleBookBUb=action.payload
    },
    setLoadingofisbnookBub:(state,action)=>{
      state.LoadingofisbnBookBub=action.payload
    },
    setLoadingofDealBookBub:(state,action)=>{
      state.LoadingofDealBookBub=action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchTitleBookBub.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchTitleBookBub.fulfilled, (state, action) => {
        const { data, page } = action.payload;

        const formatted = (data.bookbub_title_options|| []).map(
          (item: string) => ({
            label: item,
            value: item,
          })
        );
        console.log(formatted,"bookbub_title_options");
        if (page === 1) {
          state.TitleBookBubOption = formatted;
        } else {
          state.TitleBookBubOption = [
            ...state.TitleBookBubOption,
            ...formatted,
          ];
        }

        state.currentPage = page;
        state.hasMore = data.hasMore;
        state.loading = false;
      })
      .addCase(FetchTitleBookBub.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) ?? "Fetch failed";
      });
  },
});

export const { clearTitleBookBubOptions ,setLoadingofDealBookBub,setLoadingofTitleBookBub,setLoadingofisbnookBub} =
  TitleBookBubOptionsSlice.actions;
export default TitleBookBubOptionsSlice.reducer;
